import {
  Accordion,
  AccordionTrigger,
  AccordionContent,
  VStack,
  ChevronUpIcon,
  ChevronDownIcon,
  AccordionIcon,
  AccordionItem,
  AccordionHeader,
  HStack
} from "@gluestack-ui/themed";
import { Button } from "@repo/core/components/core/Button";
import { Text } from "@repo/core/components/core/Text";
import { ProposalAccordionProps } from "@repo/core/components/layout/ProposalAccordion/types";
import { useState } from "react";

export const AccordionContainer = ({
  title,
  isOpen,
  value,
  onPressEdit,
  isShowEditButton,
  bg = "$backgroundLight0",
  children
}: ProposalAccordionProps) => {
  const [isExpanded, setIsExpanded] = useState(isOpen);
  return (
    // We need to pass an array of items to Accordion to control expanded state, so we can default to expanded state if needed.
    // We use this hack as each accordion is individual in our case.
    <Accordion
      bg={bg}
      value={isExpanded ? [value] : []}
      onValueChange={() =>
        setIsExpanded((prevState) => {
          return !prevState;
        })
      }
    >
      <AccordionItem value={value}>
        <AccordionHeader bg={bg}>
          <AccordionTrigger
            p="$0"
            hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
          >
            {({ isExpanded }) => {
              return (
                <HStack flex={1} justifyContent="space-between">
                  <Text fontSize="$lg" fontWeight={600} color="$textLight900">
                    {title}
                  </Text>
                  {isExpanded ? (
                    <AccordionIcon as={ChevronUpIcon} ml="$3" />
                  ) : (
                    <AccordionIcon as={ChevronDownIcon} ml="$3" />
                  )}
                </HStack>
              );
            }}
          </AccordionTrigger>
        </AccordionHeader>
        <AccordionContent bg={bg} p="$0" pt="$6" gap="$6">
          <VStack gap="$4">{children}</VStack>
          {isShowEditButton && onPressEdit && (
            <Button
              variant="outline"
              action="secondary"
              size="md"
              text="Editar"
              onPress={onPressEdit}
              leftIcon={{
                name: "pen-square",
                color: "$secondary900",
                size: 20
              }}
            />
          )}
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};
